export default "__VITE_ASSET__BXpYAvL7__"